(function() {
    'use strict';
    angular.module('wbDashboard')
    .factory('MoreInfoService', ['$q', '$rootScope', '$timeout', '$uibModal', function ($q, $rootScope, $timeout, $uibModal) {

        var info = {
            instance: {},
            display: false,
            template: null,
            scopes: []
        };

        info.show = function(scope) {
            addScope(scope);
            info.display = true;
        };
        info.hide = function() {
            info.display = false;
        };
        info.showing = function() {
            return info.display;
        };
        info.setTemplate = function(template) {
            info.template = template;
        };

        function addScope(scope) {
            if (!info.scopes.includes(scope)) {

                scope.$on('$destroy', function() {
                    var index = info.scopes.indexOf(scope);
                    if (index > -1) {
                        info.scopes.splice(index, 1);
                    }
                    if (info.scopes.length === 0) {
                        info.hide();
                    }
                });

                info.scopes.push(scope);
            }
        }

        info.open = function(template, inheritedScope = info.scopes.slice(-1)[0]) {

            //haven't thought about how to determine scope when multiple parent scopes
            //perhaps just using the last one would work and children scopes will be destroyed
            //before going back to parent.

            if (!inheritedScope) {
                inheritedScope = $rootScope.$new(true);
            }

            if (!template && inheritedScope.pageData && inheritedScope.pageData.infoTemplate) {
                template = inheritedScope.pageData.infoTemplate;
            } else if (!template) {
                console.error('No information template supplied');
                template = 'app/themes/aurea/directives/more-info/more-info-modal.tpl.html';
            }

            info.instance = $uibModal.open({
                templateUrl: template,
                scope: inheritedScope,
                size: "lg",
                windowClass:"more-info-modal slide-up-up"
            });

            //prevent unhandled rejection message
            info.instance.result.catch(angular.noop);

            return info.instance;
        };

        info.close = function(imediate, key) {

            info.instance.close();

        };

        return info;

    }])


    .directive('moreInfo',
    ['$rootScope', '$transitions', '$window', '$timeout', 'MoreInfoService',
    function ($rootScope, $transitions, $window, $timeout, MoreInfoService) {
        return {
            restrict: 'A',
            replace: true,
            scope: false, //parent is only rootScope, so not useful
            templateUrl: 'app/themes/aurea/directives/more-info/more-info.tpl.html',
            link: function (scope, element) {

                scope.infoData = {
                    show: false,
                };

                scope.showInfo = function() {
                    MoreInfoService.open();
                };

                $rootScope.$watch(function() { return MoreInfoService.showing(); }, function(showInfo) {
                    scope.infoData.show = showInfo;
                });
            }
        };
    }]);
})();
